import { Box, IconButton } from '@mui/material';
import { VyIcon } from '@vy/ui-design-system';
import React from 'react';

type FilterDeleteButtonProps = {
  onDelete: () => void;
};

export const FilterDeleteButton: React.FC<FilterDeleteButtonProps> = React.memo(({ onDelete }) => (
  <Box sx={{ width: '70px', display: 'flex', justifyContent: 'end' }}>
    <IconButton size="small" onClick={onDelete}>
      <VyIcon icon="Delete" />
    </IconButton>
  </Box>
));
